/*
 * @Author: v-liangkai1 v-liangkai1@xiaomi.com
 * @Date: 2024-06-19 14:08:17
 * @LastEditors: v-liangkai1 v-liangkai1@xiaomi.com
 * @LastEditTime: 2024-07-22 10:13:04
 * @FilePath: src/pages/Channel/Downloads/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useState, useEffect, useRef } from 'react'
import globalStyles from '../../global.less'
import styles from './index.less'
import backgroundImg from './assets/phone_bg.png'
import footerImg from './assets/footer1.png'
import androidIcon from '../../../assets/android_icon.png'
import iosIcon from '../../../assets/ios_icon.png'
// import HanddImg from './assets/hand.png'
import { API_RetailDownloadsUrl } from '../../../api/url'
import nextWork from '../../../utils/net'
import Toast from '../../../components/toast'
import { setTitleDesc } from '../../../utils/tools'

// 设备检测工具函数
const detectDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera
  
  // 检测iOS设备
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream
  
  // 检测Android设备
  const isAndroid = /android/i.test(userAgent)
  
  return {
    isIOS,
    isAndroid,
    isMobile: isIOS || isAndroid
  }
}

function DownloadsPage() {
  const [androidUrl, setAndroidUrl] = useState('')
  const [iosUrl, setIosUrl] = useState('')
  const [showTipsModal, setShowTipsModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [downloadType, setDownloadType] = useState('')
  const [pendingDownload, setPendingDownload] = useState<{url: string, type: string} | null>(null)
  const [deviceInfo, setDeviceInfo] = useState({ isIOS: false, isAndroid: false, isMobile: false })
  const loadingTimerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    // 检测设备类型
    const device = detectDevice()
    setDeviceInfo(device)
      
    setTitleDesc('Xiaomi Channel', '小米分销通')
    const params = [
      {
        appKey: 'fenxiaotong',
        configKey: ['h5_apk_download'],
      },
    ]
    console.log(API_RetailDownloadsUrl)
    nextWork.post(API_RetailDownloadsUrl, params).then((res: any) => {
      if (res && res.code === 0) {
        const { data } = res || {}
        const { h5_apk_download } = data || {}
        setAndroidUrl(h5_apk_download?.android_url)
        setIosUrl(h5_apk_download?.ios_url)
      } else {
        Toast.error(res?.message ?? 'Download failed, please try again later')
      }
    })
  }, [])

  // 清理定时器
  useEffect(() => {
    return () => {
      if (loadingTimerRef.current) {
        clearTimeout(loadingTimerRef.current)
      }
    }
  }, [])

  const onDownLoad = (url: string, type: string) => {
    if(!url) {
      return
    }
    
    // 设置待下载信息并显示tips弹窗
    setPendingDownload({url, type})
    setShowTipsModal(true)
  }

  const handleCloseTips = () => {
    setShowTipsModal(false)
    // 清除待下载信息
    setPendingDownload(null)
  }

  const handleConfirmDownload = () => {
    if (pendingDownload) {
      const { url, type } = pendingDownload
      
      // 开始loading
      setIsLoading(true)
      setDownloadType(type)
      // 5秒后自动取消loading
      loadingTimerRef.current = setTimeout(() => {
        setIsLoading(false)
        setDownloadType('')
      }, 5000)
      
      // 执行下载
      window.location.href = url
    }
    
    // 关闭弹窗并清除待下载信息
    setShowTipsModal(false)
    setPendingDownload(null)
  }

  const handleHelpClick = () => {
    setShowTipsModal(true)
  }

  const renderLoading = () => {
    return (
      <div className={styles['loading_spinner']}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="rgba(255, 255, 255, 0.2)" strokeWidth="2"/>
          <circle cx="12" cy="12" r="10" stroke="#FFF6E6" strokeWidth="2" strokeLinecap="round" strokeDasharray="31.416" strokeDashoffset="23.562"/>
        </svg>
      </div>
    )
  }

  const renderIosTips = () => {
    return (
      <div className={styles['ios_tips']}>
        <p>1. Go to General -&gt; Device Management.</p>
        <p>2. Select the app that needs to be trusted.</p>
        <p>3. Tap Trust "Beijing Xiaomi Communications Co., Ltd.".</p>
      </div>
    )
  }

  const renderAndroidTips = () => {
    return (
      <div className={styles['android_tips']}>
        <p>1. Open the "Settings" app on your phone, scroll down and tap "App Settings".</p>
        <p>2. Find and tap "Security Settings", locate "Unknown Sources", and toggle the button to enable this option.</p>
        <p>3. Use a file manager or browser to download and install the APK file. During installation, the system will prompt you to grant trust permissions to the app. Select "Continue Installation", then tap "Trust This App" to complete the installation.</p>
      </div>
    )
  }

  return (
    <div className={[globalStyles["container"], styles["viewport"]].join(" ")}>
      <img className={styles["phone"]} src={backgroundImg} alt="" />
      <img className={styles["footer"]} src={footerImg} alt="" />

      {!!iosUrl && (
        <div
          className={[
            styles["download_btn"],
            styles["download_btn--ios"],
            isLoading ? styles["download_btn--loading"] : "",
          ].join(" ")}
          onClick={() => onDownLoad(iosUrl, "ios")}
        >
          <img className={styles["ios_icon"]} src={iosIcon} alt="" />
          {isLoading && downloadType === "ios" ? (
            <>
              <span>Downloading</span>
              {renderLoading()}
            </>
          ) : (
            <span>Download IOS</span>
          )}
        </div>
      )}
      {!!androidUrl && (
        <div
          className={[
            styles["download_btn"],
            styles["download_btn--android"],
            isLoading ? styles["download_btn--loading"] : "",
          ].join(" ")}
          onClick={() => onDownLoad(androidUrl, "android")}
        >
          <img className={styles["android_icon"]} src={androidIcon} alt="" />
          {isLoading && downloadType === "android" ? (
            <>
              <span>Downloading</span>
              {renderLoading()}
            </>
          ) : (
            <span>Download Android</span>
          )}
        </div>
      )}

      {/* Help按钮 */}
      <div className={styles["help_button"]} onClick={handleHelpClick}>
        <span>Help</span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.66667 12L10.6667 8L6.66667 4"
            stroke="#5F6A7A"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Tips弹窗 */}
      {showTipsModal && (
        <div className={styles["modal_overlay"]} onClick={handleCloseTips}>
          <div
            className={styles["modal_content"]}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles["modal_header"]}>
              <h3 className={styles["modal_title"]}>Tips</h3>
            </div>
            <div className={styles["modal_body"]}>
              <p>
                Before using the Xiaomi Channel APP, please note to add "Beijing
                Xiaomi Communications Co., Ltd." to your trusted list to avoid
                affecting your usage.
              </p>
              {deviceInfo.isIOS ? (
                <>
                  <p style={{ fontWeight: "bold", padding: "8ox 0" }}>
                    Operation Steps:
                  </p>
                  {renderIosTips()}
                </>
              ) : deviceInfo.isAndroid ? (
                <>
                  <p style={{ fontWeight: "bold", padding: "8ox 0" }}>
                    Operation Steps:
                  </p>
                  {renderAndroidTips()}
                </>
              ) : (
                <>
                  <p style={{ fontWeight: "bold", padding: "8ox 0" }}>
                    IOS Operation Steps:
                  </p>
                  {renderIosTips()}
                  <p style={{ fontWeight: "bold", padding: "8ox 0" }}>
                    Android Operation Steps:
                  </p>
                  {renderAndroidTips()}
                </>
              )}
            </div>
            {pendingDownload ? (
              <div className={styles["modal_footer"]}>
                <div
                  className={[
                    styles["modal_button"],
                    styles["modal_button--cancel"],
                  ].join(" ")}
                  onClick={handleCloseTips}
                >
                  Cancel
                </div>
                <div
                  className={styles["modal_button"]}
                  onClick={handleConfirmDownload}
                >
                  Install
                </div>
              </div>
            ) : (
              <div className={styles["modal_footer"]}>
                <div
                  className={styles["modal_button"]}
                  onClick={handleConfirmDownload}
                >
                  I Know
                </div>
              </div>
            )}
            <div className={styles["modal_handle"]}>
              <div className={styles["modal_handle_bar"]}></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(DownloadsPage)
